export const PROGRAM_STRUCTURE_2_CONSTANTS = {
  PROGRAM_STRUCTURE_V2_FIELDS_CONFIG: [
    {
      fieldName: "layout_variant",
      label: "Layout Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Layout Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
      ],
    },
    {
      fieldName: "title_1",
      label: "Title 1",
      value: "Learn What the ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 1",
      required: false,
      defaultValue: "Learn What the ",
    },
    {
      fieldName: "title_1_color",
      label: "Title 1 Color",
      value: "#CCCCCC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title 1 color",
      required: false,
      defaultValue: "#CCCCCC",
    },
    {
      fieldName: "title_2",
      label: "Title 2",
      value: "Industry Actually Uses",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 2",
      required: false,
      defaultValue: "Industry Actually Uses",
    },
    {
      fieldName: "title_2_gradient_start_color",
      label: "Title 2 Gradient Start Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter gradient start color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_2_gradient_end_color",
      label: "Title 2 Gradient End Color",
      value: "#02a7b6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter gradient end color",
      required: false,
      defaultValue: "#02a7b6",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter description",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "#B3B3B3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color",
      required: false,
      defaultValue: "#B3B3B3",
    },
    {
      fieldName: "credits_text",
      label: "Credits Text",
      value: "Total Credits:",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter credits text",
      required: false,
      defaultValue: "Total Credits:",
    },
    {
      fieldName: "credits_text_color",
      label: "Credits Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter credits text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "total_credits",
      label: "Total Credits",
      value: "125",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter total credits",
      required: false,
      defaultValue: "125",
    },
    {
      fieldName: "total_credits_color",
      label: "Total Credits Color",
      value: "#0febff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter total credits color",
      required: false,
      defaultValue: "#0febff",
    },
    {
      fieldName: "table_heading_1",
      label: "Table Heading 1 (Type)",
      value: "Type",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter table heading 1",
      required: false,
      defaultValue: "Type",
    },
    {
      fieldName: "table_heading_1_color",
      label: "Table Heading 1 Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter table heading 1 color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "table_heading_2",
      label: "Table Heading 2 (Subjects)",
      value: "Subjects",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter table heading 2",
      required: false,
      defaultValue: "Subjects",
    },
    {
      fieldName: "table_heading_2_color",
      label: "Table Heading 2 Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter table heading 2 color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "table_heading_3",
      label: "Table Heading 3 (Credits)",
      value: "Credits",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter table heading 3",
      required: false,
      defaultValue: "Credits",
    },
    {
      fieldName: "table_heading_3_color",
      label: "Table Heading 3 Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter table heading 3 color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "table_header_background_color",
      label: "Table Header Background Color (Variant 2)",
      value: "#9f1c34",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter table header background color",
      required: false,
      defaultValue: "#9f1c34",
    },
    {
      fieldName: "table_total_text",
      label: "Table Total Text",
      value: "Total",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter total text",
      required: false,
      defaultValue: "Total",
    },
    {
      fieldName: "table_total_text_color",
      label: "Table Total Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter total text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "note",
      label: "Note",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter note (e.g., *Highlighted subjects are subjects as per CFP curriculum.)",
      required: false,
      defaultValue: "",
      rows: 2,
    },
    {
      fieldName: "note_color",
      label: "Note Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter note color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_button_text",
      label: "CTA Button Text",
      value: "Download Brochure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA button text",
      required: false,
      defaultValue: "Download Brochure",
    },
    {
      fieldName: "cta_button_text_color",
      label: "CTA Button Text Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button text color",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "cta_button_background_color",
      label: "CTA Button Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button background color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_button_icon",
      label: "CTA Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA button icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_button_icon_alt",
      label: "CTA Button Icon Alt Text",
      value: "Download Brochure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA button icon alt text",
      required: false,
      defaultValue: "Download Brochure",
    },
    {
      fieldName: "cta_button_shadow_enabled",
      label: "CTA Button Drop Shadow (Variant 2)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable CTA button drop shadow",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "cta_button_shadow_color",
      label: "CTA Button Shadow Color (Variant 2)",
      value: "rgba(202,125,139,0.6)",
      valueType: "string",
      filedType: "COLOR",
      // Pick the hue only — the widget always renders it at 60% opacity so the
      // shadow stays a soft glow (same as Program Fee 3) instead of a hard slab.
      placeholder: "Shadow hue — softened to 60% opacity automatically",
      required: false,
      defaultValue: "rgba(202,125,139,0.6)",
    },
    {
      fieldName: "tools_title",
      label: "Tools Title",
      value: "Tools You'll Master",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter tools section title",
      required: false,
      defaultValue: "Tools You'll Master",
    },
    {
      fieldName: "tools_title_color",
      label: "Tools Title Color",
      value: "#4cecfa",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter tools title color",
      required: false,
      defaultValue: "#4cecfa",
    },
    {
      fieldName: "skills_title",
      label: "Skills Title",
      value: "Skills You'll Acquire",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter skills section title",
      required: false,
      defaultValue: "Skills You'll Acquire",
    },
    {
      fieldName: "skills_title_color",
      label: "Skills Title Color",
      value: "#4cecfa",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter skills title color",
      required: false,
      defaultValue: "#4cecfa",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Background Color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "status",
      label: "Program Structure V2 Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Program Structure V2",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    },
  ],

  SEMESTER_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Semester Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter semester name (e.g., Semester 1)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "text_color",
      label: "Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "active_color",
      label: "Active BG Color",
      value: "#02a7b6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter active button background color",
      required: false,
      defaultValue: "#02a7b6",
    },
    {
      fieldName: "active_text_color",
      label: "Active Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter active button text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "order_index",
      label: "Priority (Order)",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
  ],

  CATEGORY_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Category Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter category name (e.g., Major, Minor)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "text_color",
      label: "Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "select_color",
      label: "Row Background Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter row background color",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "order_index",
      label: "Priority (Order)",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
  ],

  CATEGORY_ITEM_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Item Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter item name (e.g., Finance, Marketing)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "text_color",
      label: "Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "priority",
      label: "Priority (Order)",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
  ],

  SUBJECT_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Subject Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter subject name",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "type",
      label: "Type",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter type (e.g., major, minor)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "credits",
      label: "Credits",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter credits",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "text_color",
      label: "Row Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter row text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "is_elective",
      label: "Is Elective",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Is this an elective subject?",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "priority",
      label: "Priority (Order)",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
  ],

  ELECTIVE_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Elective Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter elective name",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "text_color",
      label: "Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "priority",
      label: "Priority (Order)",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
  ],

  TOOL_FIELDS_CONFIG: [
    {
      fieldName: "image",
      label: "Tool Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload tool image",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter image alt text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#1A1A1A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color",
      required: false,
      defaultValue: "#1A1A1A",
    },
  ],

  SKILL_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Skill Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter skill name",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "icon",
      label: "Skill Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload skill icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_icon",
      label: "Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter icon alt text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "text_color",
      label: "Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#1A1A1A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color",
      required: false,
      defaultValue: "#1A1A1A",
    },
  ],
};
